import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";

import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import { imageBaseURL } from "../../../utils/fetchData";
import QuickLinks from "../../../components/Common/QuickLinks";
import { getMenu, getPageTitle } from "../../../utils/getDomainData";
import { useLocation } from "react-router-dom";

const Profile = () => {
  const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
  const { state } = useLocation();
  const user = state?.data?.attributes;

  return (
    <React.Fragment>
      <Helmet>
        <title>Profile – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Profile"
          pageName="Profile"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <div className={`col-lg-4 md-mb-30 ${currentDomain === "sree"  ? 'mx-auto' : ''}`}>
                      <div className="img-part">
                        <img
                          className="about-main w-100"
                          src={
                            imageBaseURL + user?.Image?.data?.attributes?.url
                          }
                          alt={user?.attributes?.Name}
                          title={user?.attributes?.Name}
                        />
                      </div>
                    </div>
                    <h3 style={{ marginTop: "10px" }} className={`${currentDomain === "sree"  ? 'text-center' : ''}`}>{user?.Name}</h3>
                    <p className={`${currentDomain === "sree"  ? 'text-center' : ''}`}>{user?.Education}</p>
                    <p className={`${currentDomain === "sree"  ? 'text-center' : ''}`}>
                      {user?.Designation} <br />
                      {getPageTitle()}
                    </p>

                  
                    {user?.Research_Interest && (
                      <>
                        <p>
                          <b>Research Interest:</b>
                        </p>
                        <p>{user?.Research_Interest}</p>
                      </>
                    )}

                    {user?.Contact_Details && (
                      <>
                        <p>
                          <b>Contact Details:</b>
                        </p>
                        <p>{user?.Contact_Details}</p>
                      </>
                    )}

                    <p>{user?.About}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default Profile;


